<template>
    <div class="venue-location-and-time-profile w-100" v-if="venue">
        <div class="white-block">
            <span class="d-flex align-items-center"> <icon-component
                :icon="mapPin()"></icon-component> {{ translate.home.location }}</span>
            <b>{{ address }}</b>
        </div>

        <div v-if="venue.venue_working_hours" class="white-block">
            <span class="d-flex align-items-center"> <icon-component
                :icon="fa_clock()"></icon-component> {{ translate.account.conversations.today }}</span>
            <b v-if="todayWorkingHours">{{ todayWorkingHours.time_start }} - {{ todayWorkingHours.time_end }}</b>
            <b v-else>{{ translate.account.closed }}</b>
        </div>

        <a class="white-block white-block--website" @click.prevent="goToWebsite()"
           :href="getUrl(venue.venueFeatures.websiteUrl)" rel="nofollow"
           v-if="venue.venueFeatures && venue.venueFeatures.websiteUrl && isGoldUser(venue)">
            <span class="d-flex align-items-center"><icon-component
                :icon="fa_globe_americas()"></icon-component> {{ translate.user_features.website_url }}</span>
            <b :title="venue.venueFeatures.websiteUrl">{{ venue.venueFeatures.websiteUrl }}</b>
        </a>
    </div>
</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import {fa_clock, fa_globe_americas, mapPin} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import {isUnitedKingdomRegion} from "@/core/utils/helpers/regions/regionUrlHelper";

const data = () => {
    return {
        moment: moment,
        yesterdayWorkingHours: undefined,
        todayWorkingHours: undefined,
    }
};

function goToWebsite() {
    let finalUrl = this.getUrl(this.venue.venueFeatures.websiteUrl)

    this.captureTrackingEvent(this.currentUser, 'profile', 'venue_external_link', 'click')
    window.open(finalUrl, '_blank').focus();
}

export default {
    components: {IconComponent},
    data,
    created() {
        if (_.get(this, 'venue.venue_working_hours')) {
            const todayDayOfWeek = this.moment().isoWeekday() - 1;
            const yesterdayDayOfWeek = todayDayOfWeek <= 0 ? 6 : todayDayOfWeek - 1;
            let dayToDisplay = todayDayOfWeek;

            if (this.moment().isBefore(this.moment('06:00', 'HH:mm'))) {
                dayToDisplay = yesterdayDayOfWeek;
            }

            this.todayWorkingHours = this.venue.venue_working_hours.find((e) => {
                return e.day === dayToDisplay;
            });
        }
    },
    computed: {
        ...mapState(['translate']),
        address() {
            let addressParts = [
                _.get(this, 'venue.street', ''),
                _.get(this, 'venue.suburb', ''),
                _.get(this, 'venue.city', ''),
                _.get(this, 'venue.postcode', ''),

            ];

            if (isUnitedKingdomRegion()) {
                addressParts = [
                    _.get(this, 'venue.city', ''),
                    _.get(this, 'venue.suburb', ''),
                ];
            }

            return addressParts
                .filter(item => !_.isEmpty(item))
                .join(', ');
        },
    },
    methods: {
        mapPin,
        fa_globe_americas,
        fa_clock,
        goToWebsite,
    },
    mixins: [userMixin, xtrackingMixin],
    props: ['venue'],
}
</script>
